module.exports = __webpack_public_path__ + "img/22.f2aab961.jpg";